import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'
import { cn } from 'shared/utils'

import styles from './AccordionGlobalTitle.module.scss'

const AccordionGlobalTitle: FC<{ title: string; className?: string; }> = ({ title, className }) => (
  <h4 className={cn(styles.listTitle, className)}>{title}&nbsp;
    <Icon prefix="fas" name="badge-check" className={styles.listIcon} />
  </h4>
)

export default AccordionGlobalTitle
